import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import { Link } from "react-router-dom";

const domains = [
  { num: "01", title: "Branding & identité visuelle", desc: "Création de systèmes visuels complets : logos, typographies, palettes chromatiques et chartes graphiques." },
  { num: "02", title: "Design graphique", desc: "Conception de supports de communication digitaux et imprimés, de haute qualité esthétique." },
  { num: "03", title: "Direction artistique", desc: "Définition et pilotage de la vision créative globale d'un projet, de la conception à la livraison." },
  { num: "04", title: "Conception visuelle", desc: "Accompagnement créatif personnalisé pour entreprises, start-ups et projets indépendants." },
];

export default function About() {
  return (
    <main>
      <Navbar />

      {/* Hero */}
      <section className="pt-40 pb-20 lg:pt-52 lg:pb-28 bg-white">
        <div className="max-w-7xl mx-auto px-8 lg:px-16">
          <span className="font-sans text-xs tracking-widest uppercase text-brand-gris-light">
            À propos
          </span>
          <h1 className="font-serif font-light text-brand-noir text-5xl lg:text-6xl xl:text-7xl leading-tight mt-6 max-w-3xl">
            Un studio indépendant de design basé à Bordeaux.
          </h1>
        </div>
      </section>

      {/* Biography section */}
      <section className="py-20 lg:py-28 bg-white">
        <div className="max-w-7xl mx-auto px-8 lg:px-16">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-start">
            {/* Left: Image */}
            <div className="relative">
              <div className="w-full h-[500px] lg:h-[620px] overflow-hidden">
                <img
                  src="https://public.readdy.ai/ai/img_res/28dd1197b067b6e31d6480ad4ee7417f.jpg"
                  alt="Oskar Arkadiusz Marcinski – Designer"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              {/* Caption */}
              <div className="mt-5 border-l-2 border-brand-or pl-4">
                <p className="font-serif italic text-brand-gris text-sm">
                  Oskar Arkadiusz Marcinski
                </p>
                <p className="font-sans text-xs text-brand-gris-light tracking-wider uppercase mt-1">
                  Designer & Fondateur
                </p>
              </div>
            </div>

            {/* Right: Text */}
            <div className="pt-4 lg:pt-8">
              <p className="font-sans font-light text-brand-gris text-lg leading-loose mb-6">
                MARCINSKI est un studio indépendant de design basé à Bordeaux. Le studio est
                dirigé par <strong className="font-medium text-brand-noir">Oskar Arkadiusz Marcinski</strong>,
                designer spécialisé dans la création d'identités visuelles et de concepts graphiques.
              </p>
              <p className="font-sans font-light text-brand-gris text-lg leading-loose mb-6">
                Son travail s'inscrit dans une démarche contemporaine, alliant esthétique, clarté
                et stratégie visuelle. Chaque projet est pensé avec une exigence absolue, pour
                produire des résultats à la fois durables et distinctifs.
              </p>
              <p className="font-sans font-light text-brand-gris text-lg leading-loose mb-10">
                Chaque collaboration est guidée par une recherche d'excellence, une attention
                aux détails et une compréhension précise des besoins du client.
              </p>

              {/* Values */}
              <div className="grid grid-cols-3 gap-6 pt-10 border-t border-gray-100">
                {["Excellence", "Précision", "Créativité"].map((v) => (
                  <div key={v} className="text-center">
                    <div className="w-8 h-px bg-brand-or mx-auto mb-3"></div>
                    <p className="font-sans text-xs tracking-widest uppercase text-brand-gris-light">
                      {v}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Domains */}
      <section className="bg-brand-gris-pale py-24 lg:py-36">
        <div className="max-w-7xl mx-auto px-8 lg:px-16">
          <div className="mb-16">
            <span className="font-sans text-xs tracking-widest uppercase text-brand-gris-light">
              Domaines d'intervention
            </span>
            <h2 className="font-serif font-light text-brand-noir text-4xl lg:text-5xl mt-4 max-w-lg leading-tight">
              Une expertise pluridisciplinaire
            </h2>
          </div>

          <div className="flex flex-col gap-0">
            {domains.map((d, i) => (
              <div
                key={i}
                className="relative flex flex-col lg:flex-row items-start lg:items-center gap-4 lg:gap-0 py-10 border-b border-gray-200 group cursor-default"
              >
                {/* Number */}
                <span className="lg:absolute left-0 font-serif text-6xl lg:text-8xl text-brand-noir/[0.06] select-none leading-none">
                  {d.num}
                </span>

                {/* Content */}
                <div className="lg:ml-28 flex-1">
                  <h3 className="font-serif font-light text-brand-noir text-2xl lg:text-3xl group-hover:text-brand-or transition-colors duration-300">
                    {d.title}
                  </h3>
                  <p className="font-sans font-light text-brand-gris text-sm leading-loose mt-3 max-w-xl">
                    {d.desc}
                  </p>
                </div>

                {/* Arrow */}
                <div className="w-10 h-10 flex items-center justify-center text-brand-or opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex-shrink-0">
                  <i className="ri-arrow-right-line text-xl"></i>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Band */}
      <section className="bg-brand-noir py-24 text-center">
        <div className="max-w-3xl mx-auto px-8">
          <h2 className="font-serif font-light text-white text-3xl lg:text-4xl mb-6 leading-tight">
            Prêt à démarrer votre projet créatif ?
          </h2>
          <p className="font-sans font-light text-white/50 mb-10 leading-loose">
            Chaque collaboration commence par un échange. Contactez le studio pour discuter de vos besoins.
          </p>
          <Link
            to="/contact"
            className="inline-flex items-center gap-3 px-10 py-4 border border-brand-or text-brand-or font-sans text-sm tracking-widest uppercase hover:bg-brand-or hover:text-brand-noir transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            Prendre contact
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </section>

      <Footer />
    </main>
  );
}
